export class IdDescricao {
  Id: number;
  Descricao = '';
  Extra1: any;
  Extra2: any;
  Extra3: any;
  Extra4: any;

  constructor(Id?: number, Descricao?: string, Extra1?: any, Extra2?: any, Extra3?: any, Extra4?: any) {
    this.Id = Id;
    this.Descricao = Descricao;
    this.Extra1 = Extra1;
    this.Extra2 = Extra2;
    this.Extra3 = Extra3;
    this.Extra4 = Extra4;
  }
}
